var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { AccordionSet, ConfirmationModal, MessageBanner, Pane, } from '@folio/stripes/components';
import useProposalDetail from '../../hooks/useProposalDetail';
import DetailLoadingState from '../DetailLoadingState';
import ProposalMetadataSection from './ProposalMetadataSection';
import { useProposalReviewActions } from './useProposalReviewActions';
import DetailActions from '../DetailActions';
import MarcDataDisplay from '../RecordDetail/MarcDataDisplay';
import MarcDiffDisplay from './MarcDiffDisplay';
import TargetRecordStateBanner from '../TargetRecordState';
import { submitProposal, publishProposal, deleteProposal } from '../../api/proposalService';
import { ProposalStatus, ProposalType, proposalAllows } from '../../types/api';
import { getErrorInfo } from '../../utils/getErrorCode';
import { getErrorKind } from '../../utils/errorKind';
import { parseValidationFailedError } from '../../api/validationService';
import { ValidationIssueList } from '../Validation/ValidationIssueList';
import { PROPOSALS_QUERY_ROOT } from '../../hooks/useProposalList';
/**
 * The proposal detail pane, pane included.
 * Handles loading, error (404 / network), and success states.
 * Shows Edit + one of Submit/Publish + Delete for DRAFT proposals. CZNA-598: which buttons appear
 * is entirely the backend's answer, read from `proposal.actions` — including the CZNA-581
 * rule that publish and submit are decided by authority type and are mutually exclusive.
 * This component owns no permission rule of its own.
 *
 * <p>CZNA-778 — it renders its own `Pane` because the actions sit in the pane HEADER
 * (`lastMenu`), the way the proposal list keeps "Nový návrh" in its own. A host that
 * wrapped this in its `Pane` could not reach that slot.
 */
var ProposalDetailView = function (_a) {
    var _b;
    var id = _a.id, onClose = _a.onClose, paneProps = _a.paneProps;
    var intl = useIntl();
    var history = useHistory();
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var _c = useProposalDetail(id), proposal = _c.proposal, isLoading = _c.isLoading, isError = _c.isError, error = _c.error, refetch = _c.refetch;
    var review = useProposalReviewActions(proposal, id, onClose);
    var _d = useState(false), showSubmitModal = _d[0], setShowSubmitModal = _d[1];
    var _e = useState(null), submitErrorId = _e[0], setSubmitErrorId = _e[1];
    // CZNA-582: the validation gate on "odeslat ke schválení" answers 422 with the full
    // issue list. Held separately from `submitErrorId` because it is the one refusal the
    // author can act on without leaving this pane — the issues say which fields.
    var _f = useState(null), submitValidation = _f[0], setSubmitValidation = _f[1];
    var submitMutation = useMutation(function () { return submitProposal(ky, id); }, {
        onSuccess: function () {
            setSubmitErrorId(null);
            setSubmitValidation(null);
            queryClient.invalidateQueries(['proposal', id]);
            queryClient.invalidateQueries([PROPOSALS_QUERY_ROOT]);
            onClose();
        },
        // CZNA-594 — 403 gets its own message. The backend refuses a foreign proposal with
        // "you are not the author"; reporting that as the generic "submit failed" invites the
        // user to retry something that can never succeed. The button is hidden for a
        // non-author, so this path is reachable mainly via a stale detail pane or a direct URL.
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            var failure, info, status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, parseValidationFailedError(err)];
                    case 1:
                        failure = _a.sent();
                        if (failure) {
                            setSubmitValidation(failure.validationResult);
                            setSubmitErrorId('ui-czna-authorities.proposals.detail.submitValidationFailed');
                            return [2 /*return*/];
                        }
                        setSubmitValidation(null);
                        return [4 /*yield*/, getErrorInfo(err)];
                    case 2:
                        info = _a.sent();
                        // CZNA-1625 — no answer in time: the proposal may have been submitted. Not "failed";
                        // check first — and refetch, so the pane itself shows the state it is now in.
                        if (getErrorKind(info) === 'timeout') {
                            queryClient.invalidateQueries(['proposal', id]);
                            setSubmitErrorId('ui-czna-authorities.error.timeout');
                            return [2 /*return*/];
                        }
                        status = info.status;
                        setSubmitErrorId(status === 403
                            ? 'ui-czna-authorities.proposals.detail.submitForbidden'
                            : 'ui-czna-authorities.proposals.detail.submitError');
                        return [2 /*return*/];
                }
            });
        }); },
    });
    // CZNA-581 — "Publikovat". Mirrors the submit mutation above field for field: same
    // author-only refusal shape, same validation-gate shape (v3.1 §6 runs the identical
    // pre-flight rules for both buttons). Kept as its own mutation/state rather than
    // parameterizing the one above because the two buttons are mutually exclusive per
    // authority type (ApprovalWorkflow#publishesImmediately) — a proposal never needs both.
    var _g = useState(false), showPublishModal = _g[0], setShowPublishModal = _g[1];
    var _h = useState(null), publishErrorId = _h[0], setPublishErrorId = _h[1];
    var _j = useState(null), publishValidation = _j[0], setPublishValidation = _j[1];
    var publishMutation = useMutation(function () { return publishProposal(ky, id); }, {
        onSuccess: function () {
            setPublishErrorId(null);
            setPublishValidation(null);
            queryClient.invalidateQueries(['proposal', id]);
            queryClient.invalidateQueries([PROPOSALS_QUERY_ROOT]);
            onClose();
        },
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            var failure, info, status;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, parseValidationFailedError(err)];
                    case 1:
                        failure = _a.sent();
                        if (failure) {
                            setPublishValidation(failure.validationResult);
                            setPublishErrorId('ui-czna-authorities.proposals.detail.publishValidationFailed');
                            return [2 /*return*/];
                        }
                        setPublishValidation(null);
                        return [4 /*yield*/, getErrorInfo(err)];
                    case 2:
                        info = _a.sent();
                        // CZNA-1625 — see the submit mutation above: may have been published.
                        if (getErrorKind(info) === 'timeout') {
                            queryClient.invalidateQueries(['proposal', id]);
                            setPublishErrorId('ui-czna-authorities.error.timeout');
                            return [2 /*return*/];
                        }
                        status = info.status;
                        setPublishErrorId(status === 403
                            ? 'ui-czna-authorities.proposals.detail.publishForbidden'
                            : 'ui-czna-authorities.proposals.detail.publishError');
                        return [2 /*return*/];
                }
            });
        }); },
    });
    // CZNA-1375 — "Smazat". A draft is the author's scratch copy: the backend deletes it for
    // good (no history), and only while it is still a DRAFT. After a delete there is nothing
    // left to show here, so the cached detail is dropped rather than refetched into a 404.
    //
    // The dialog stays open, its confirm disabled, until the answer arrives: an irreversible
    // action should not look done before it is. The deleted id travels as the mutation's
    // variable, and `shownIdRef` says what the pane shows NOW — this pane is reused across
    // proposals (see the reset effect below), so a late answer must not close or bannerize
    // whichever proposal the user has moved on to.
    var shownIdRef = useRef(id);
    shownIdRef.current = id;
    var _k = useState(false), showDeleteModal = _k[0], setShowDeleteModal = _k[1];
    var _l = useState(null), deleteErrorId = _l[0], setDeleteErrorId = _l[1];
    var deleteMutation = useMutation(function (proposalId) { return deleteProposal(ky, proposalId); }, {
        onSuccess: function (_data, deletedId) {
            queryClient.removeQueries(['proposal', deletedId]);
            queryClient.invalidateQueries([PROPOSALS_QUERY_ROOT]);
            if (shownIdRef.current !== deletedId)
                return;
            setShowDeleteModal(false);
            setDeleteErrorId(null);
            onClose();
        },
        // 409 — the proposal left DRAFT since this pane loaded it (submitted from another
        // tab); 403 — the backend no longer counts this user as its author or an admin.
        // Neither is worth a retry, so each says why instead of "delete failed".
        onError: function (err, failedId) { return __awaiter(void 0, void 0, void 0, function () {
            var info, status, timedOut;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getErrorInfo(err)];
                    case 1:
                        info = _a.sent();
                        status = info.status;
                        timedOut = getErrorKind(info) === 'timeout';
                        if (status === 409 || timedOut)
                            queryClient.invalidateQueries(['proposal', failedId]);
                        if (shownIdRef.current !== failedId)
                            return [2 /*return*/];
                        setShowDeleteModal(false);
                        if (timedOut) {
                            setDeleteErrorId('ui-czna-authorities.error.timeout');
                            return [2 /*return*/];
                        }
                        if (status === 409) {
                            setDeleteErrorId('ui-czna-authorities.proposals.detail.deleteNotDraft');
                            return [2 /*return*/];
                        }
                        setDeleteErrorId(status === 403
                            ? 'ui-czna-authorities.proposals.detail.deleteForbidden'
                            : 'ui-czna-authorities.proposals.detail.deleteError');
                        return [2 /*return*/];
                }
            });
        }); },
    });
    // Blind-review finding (CZNA-581) — this pane is reused across proposals by prop change
    // rather than remounted (ProposalsList renders it with no `key={id}`), so a banner or an
    // open confirmation left over from the PREVIOUS proposal would otherwise still show next
    // to whichever action the newly selected one offers.
    useEffect(function () {
        setShowSubmitModal(false);
        setSubmitErrorId(null);
        setSubmitValidation(null);
        setShowPublishModal(false);
        setPublishErrorId(null);
        setPublishValidation(null);
        setShowDeleteModal(false);
        setDeleteErrorId(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
    var renderPane = function (lastMenu, body) { return (React.createElement(Pane, __assign({}, paneProps, { lastMenu: lastMenu, onClose: onClose, dismissible: true }), body)); };
    if (isLoading || isError) {
        return renderPane(null, (React.createElement(DetailLoadingState, { isLoading: isLoading, isError: isError, error: error, onClose: onClose, onRetry: function () { return refetch(); }, i18nPrefix: "proposals.detail" })));
    }
    if (!proposal) {
        return renderPane(null, null);
    }
    // CZNA-598 — every gate on this pane is now the backend's own answer, read off the
    // proposal. What used to stand here was three separate local derivations that each had
    // to be kept in step with a rule in ProposalServiceImpl: the role-and-library check
    // (canEditProposal, CZNA-601), the authorship check (CZNA-594) and the
    // publish-versus-submit branch (CZNA-581, decided by authority type). All three are in
    // ProposalActionResolver, and `actions` is the same evaluation the endpoints enforce —
    // so a button drawn here cannot be one the API refuses, and the status/type conditions
    // (DRAFT, CREATE_NEW, publishesImmediately) come with it rather than being repeated.
    //
    // Still scoped to DRAFT, and that is a DIVISION OF LABOUR, not a permission rule. This
    // pane owns the actions of a proposal nobody has looked at yet; everything from
    // PENDING_REVIEW and CHANGES_REQUESTED onwards belongs to useProposalReviewActions,
    // which builds its own Upravit / Znovu odeslat from the same `actions` list.
    // Dropping the status check drew BOTH sets at once — two "Upravit" buttons and two
    // routes to the same submit endpoint on every returned proposal (blind review, CZNA-598).
    var isDraft = proposal.status === ProposalStatus.DRAFT;
    var canEdit = isDraft && proposalAllows(proposal, 'edit');
    var canSubmit = isDraft && proposalAllows(proposal, 'submit');
    var canPublish = isDraft && proposalAllows(proposal, 'publish');
    var canDelete = isDraft && proposalAllows(proposal, 'delete');
    var handleEdit = function () {
        history.push("/czna-authorities/proposals/".concat(id, "/edit"));
    };
    var handleConfirmSubmit = function () {
        setShowSubmitModal(false);
        submitMutation.mutate();
    };
    var handleConfirmPublish = function () {
        setShowPublishModal(false);
        publishMutation.mutate();
    };
    var handleConfirmDelete = function () {
        deleteMutation.mutate(id);
    };
    // CZNA-778 — one list for the header, draft actions first (edit leads, so it is the
    // primary button); the review hook's list is empty for a draft and this one is empty
    // past it, so the two never both contribute.
    var draftActions = [];
    if (canEdit) {
        draftActions.push({
            key: 'edit',
            labelId: 'ui-czna-authorities.proposals.detail.edit',
            onClick: handleEdit,
        });
    }
    if (canPublish) {
        draftActions.push({
            key: 'publish',
            labelId: 'ui-czna-authorities.proposals.detail.publish',
            onClick: function () { return setShowPublishModal(true); },
            disabled: publishMutation.isLoading,
        });
    }
    if (canSubmit) {
        draftActions.push({
            key: 'submit',
            labelId: 'ui-czna-authorities.proposals.detail.submit',
            onClick: function () { return setShowSubmitModal(true); },
            disabled: submitMutation.isLoading,
        });
    }
    // Last on purpose: a destructive action is never the primary header button while the
    // draft offers anything else.
    if (canDelete) {
        draftActions.push({
            key: 'delete',
            labelId: 'ui-czna-authorities.proposals.detail.delete',
            onClick: function () { return setShowDeleteModal(true); },
            disabled: deleteMutation.isLoading,
        });
    }
    var headerActions = React.createElement(DetailActions, { actions: __spreadArray(__spreadArray([], draftActions, true), review.actions, true) });
    // CZNA-1525 — the record this change waits on, for author and supervisor alike. The block
    // names the same record, so it stands in should a response carry the block alone.
    var approvalBlock = proposal.approvalBlock;
    var targetRecord = (_b = proposal.targetRecord) !== null && _b !== void 0 ? _b : (approvalBlock ? {
        id: approvalBlock.targetRecordId,
        authorityId: approvalBlock.targetRecordAuthorityId,
        status: approvalBlock.targetRecordStatus,
        reviewStatus: approvalBlock.targetRecordReviewStatus,
    } : null);
    return renderPane(headerActions, (React.createElement("div", null,
        review.element,
        targetRecord && (React.createElement(TargetRecordStateBanner, { record: targetRecord, approvalBlock: approvalBlock })),
        submitErrorId && (React.createElement(MessageBanner, { type: "error" },
            React.createElement("div", { "data-test-submit-error": true },
                React.createElement(FormattedMessage, { id: submitErrorId })),
            submitValidation && submitValidation.errors.length > 0 && (React.createElement("div", { style: { marginTop: '8px' } },
                React.createElement(ValidationIssueList, { issues: submitValidation.errors }))))),
        publishErrorId && (React.createElement(MessageBanner, { type: "error" },
            React.createElement("div", { "data-test-publish-error": true },
                React.createElement(FormattedMessage, { id: publishErrorId })),
            publishValidation && publishValidation.errors.length > 0 && (React.createElement("div", { style: { marginTop: '8px' } },
                React.createElement(ValidationIssueList, { issues: publishValidation.errors }))))),
        deleteErrorId && (React.createElement(MessageBanner, { type: "error" },
            React.createElement("div", { "data-test-delete-error": true },
                React.createElement(FormattedMessage, { id: deleteErrorId })))),
        React.createElement(AccordionSet, null,
            React.createElement(ProposalMetadataSection, { proposal: proposal }),
            proposal.proposalType === ProposalType.UPDATE_EXISTING
                && proposal.originalDataFields
                && proposal.dataFields
                && proposal.dataFields.length > 0 ? (React.createElement(MarcDiffDisplay, { proposalFields: proposal.dataFields, originalFields: proposal.originalDataFields })) : (proposal.dataFields && proposal.dataFields.length > 0 && (React.createElement(MarcDataDisplay, { dataFields: proposal.dataFields })))),
        React.createElement(ConfirmationModal, { open: showSubmitModal, heading: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.submitModal.heading' }), message: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.submitModal.message' }), confirmLabel: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.submitModal.confirm' }), cancelLabel: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.submitModal.cancel' }), onConfirm: handleConfirmSubmit, onCancel: function () { return setShowSubmitModal(false); } }),
        React.createElement(ConfirmationModal, { open: showPublishModal, heading: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.publishModal.heading' }), message: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.publishModal.message' }), confirmLabel: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.publishModal.confirm' }), cancelLabel: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.publishModal.cancel' }), onConfirm: handleConfirmPublish, onCancel: function () { return setShowPublishModal(false); } }),
        React.createElement(ConfirmationModal, { open: showDeleteModal, heading: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.deleteModal.heading' }), message: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.deleteModal.message' }), confirmLabel: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.deleteModal.confirm' }), cancelLabel: intl.formatMessage({ id: 'ui-czna-authorities.proposals.detail.deleteModal.cancel' }), buttonStyle: "danger", isConfirmButtonDisabled: deleteMutation.isLoading, onConfirm: handleConfirmDelete, onCancel: function () { return setShowDeleteModal(false); } }))));
};
export default ProposalDetailView;
